import { Permission } from '@/types';
import { useAuthStore } from '@/stores';

export const can = (permission: Permission) => {
    return useAuthStore().userPermissions.includes(permission);
};
